import React from "react";

import { withCarMapState } from "../../../shared/containers/containerCarMapState";

import IntelligenceMap from "./intelligenceMap";
import IntelligenceMapControls from "./intelligenceMapControls";

import styles from "./intelligenceMapWrapper.module.scss";

const IntelligenceMapWrapper = (props) => {
  const { carMapState } = props;
  const getMapStyles = () => {
    switch (carMapState.mapSize) {
      case "baseSize":
        return styles.baseSize;
      case "fullSize":
        return styles.fullSize;
      default:
        return null;
    }
  };

  const height = window.innerHeight > 800 ? 650 : 450;

  return (
    <div className={styles.intelligenceMapWrapper} style={{ height: `${height}px` }}>
      <div className={getMapStyles()}>
        <IntelligenceMap />
      </div>
      {/*   <div className={styles.container_controls}>
        <IntelligenceMapControls />
        <IntelligenceMapControls />
      </div> */}
    </div>
  );
};

export default withCarMapState(React.memo(IntelligenceMapWrapper));
